import ShowItem from "./ShowItem";
import withCourse from "../Fetch/withCourse";

export default withCourse(ShowItem);
